<div id="recover-view" ng-controller="recoverSignatureController as ctrl">
    <div class="wrapper">
        <div class="content">
            <div class="loading"></div>
            <div class="login-wrapper">
                <form ng-if="!ctrl.recoveryMailSent" id="recover-form" ng-submit="ctrl.recoverSignature()">
                    <div class="recover-text">{{ctrl.recoverText}}</div>
                    <input type="text" name="recoverName" id="recoverName" ng-model="ctrl.recoverName" placeholder="{{'recover.userOrEmail'|translate}}" />
                    <button ng-disabled="ctrl.processing" class="recover-button" type="submit">{{'recover'|translate}}</button>
                </form>
                <div class="recover-sent" ng-if="ctrl.recoveryMailSent">
                    {{'recover.mailSent'|translate}}
                </div>

                <div ng-if="ctrl.flagSignature" class="return-to-login"><a ng-click="ctrl.returnToLogin()">{{'recover.returnToLogin'|translate}}</a></div>

                <div ng-if="ctrl.recoveryError">{{ ctrl.recoveryError }}</div>
            </div>
        </div>
    </div>
</div>